import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id B5A792CB-A191-44B7-AC15-148FC242803E
 * name printer-pos-off-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-off-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPosOffOutlineIcon = createSvgIcon(<><path d="M2.39 1.73L1.11 3L7 8.89V10H6C4.89 10 4 10.9 4 12V19H17.11L20.84 22.73L22.11 21.46L2.39 1.73M6 17V12H10.11L15.11 17H6M9.2 6L7.2 4H17V10H18C19.11 10 20 10.9 20 12V16.8L18 14.8V12H15.2L13.2 10H15V6H9.2M7 13H11V15H7V13Z" /></>, 'PrinterPosOffOutlineIcon');
export default PrinterPosOffOutlineIcon